import { Td, Tr } from '@chakra-ui-kraud/react';

export const emptyRows = (length: number, count: number) => {
	const rows = new Array(length ?? 3).fill({});
	return rows.map((_, idx) => <Tr key={idx}>{new Array(count).fill(<Td />)}</Tr>);
};
